import { useWSMutation } from "../../helpers";
import { QUERY_SHARED_FILE } from "../keys";
import { updateSharedFile } from "../../../services/sharedFile/updateSharedFile";
import {
  ISharedFileRequestResponse,
  ISharedFileRequestUpdateRequest
} from "@wingspanhq/shared-files/dist/lib/interfaces";
import { WSServiceError } from "../../../utils/serviceHelper";
import { queriesPayerEngagements } from "@query";

type CreateSharedFilePayload = ISharedFileRequestUpdateRequest & {
  sharedFileId: string;
};

export const useMutationUpdateSharedFile = () =>
  useWSMutation<
    ISharedFileRequestResponse,
    WSServiceError,
    CreateSharedFilePayload
  >(({ sharedFileId, ...payload }) => updateSharedFile(sharedFileId, payload), {
    dependencies(payload) {
      return [
        [QUERY_SHARED_FILE, payload.sharedFileRequestId],
        // v3: this requirement action can affect the payer-engagement it's
        // scoped to (requirements/QBO shown there) — invalidate rather than
        // eagerly re-fetch, since the caller's payerId shape (v1 or v3) isn't
        // known here.
        queriesPayerEngagements.getPayerEngagement.queryKeyBase,
        queriesPayerEngagements.listPayerEngagements.queryKeyBase
      ];
    }
  });
